// Copyright (c) 2022 by Move Closer

import { CreationsConfig } from './Creations.contracts'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const creationsCarouselConfig = {
  autoplay: false,
  centralize: false,
  delay: 2000,
  hasPagination: false,
  hasButtons: false,
  initialSlide: 0,
  inLoop: false,
  pauseOnHover: false,
  perPage: 2.2
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const CREATIONS_COMPONENT_KEY = 'CreationsComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const CREATIONS_CONFIG_MAP: CreationsConfig = {
  showPriceOnLocales: null
}
